/**
 * 资源访问权限 (前端体验层).
 *
 * 规则与后端 `app/services/courses.py:can_access_course` 一致:
 * 免费资源对所有登录用户开放, 其余资源要求会员在有效期内。
 * 前端只是提前拦一道给出开通引导, 最终以后端 403 `membership_required` 为准。
 */

import { authRef } from '../stores/auth'
import { toast } from '../stores/toast'
import { uiRef } from '../stores/ui'
import type { Course } from '../types/api'

/** 当前用户能否跟读该资源 */
export function canAccessCourse(course: Pick<Course, 'is_free'>): boolean {
  return course.is_free || authRef()?.isMember === true
}

/**
 * 进入跟读前调用: 会员专享资源弹出激活会员弹层并返回 false.
 *
 * 用返回布尔值而不是抛异常, 调用方在导航前一行判断即可。
 */
export function ensureCourseAccess(course: Pick<Course, 'is_free'>): boolean {
  if (canAccessCourse(course)) return true
  toast('该资源为会员专享, 请先开通会员')
  uiRef()?.openRedeem()
  return false
}
